"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTile = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _DealLabel = require("../DealLabel");
var _Image = require("./Image");
var _Price = require("./Price");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductTile = ({
  brandName,
  className,
  currentPrice,
  labels,
  mrpText,
  name,
  oldPrice,
  productCode,
  productImages,
  relativeUrl,
  testId,
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    labelKey,
    title
  } = labels?.deal ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": testId ?? getTestId(_common.PRODUCT_TILE),
    href: relativeUrl ?? undefined,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
      productImages: productImages
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Info, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DealLabel.DealLabel, {
        label: title,
        type: labelKey,
        productCode: productCode,
        size: "small"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Names, {
        children: [brandName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Brand, {
          children: brandName
        }) : null, name ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
          variant: "subtitle1",
          children: name
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.Price, {
        currentPrice: currentPrice,
        mrpText: mrpText,
        oldPrice: oldPrice
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
  });
};
exports.ProductTile = ProductTile;
